<div class="simple-input">
    <mat-form-field appearance="outline" [color]="color">
        <mat-label class="placeholder">{{text}}</mat-label>
        <input placeholder="{{placeholder}}" matInput>
    </mat-form-field>
</div>